import { Box, Grid } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect } from "react";
import Navbar from "./Drawer/Navbar/Navbar";
import Sidebar from "./Drawer/Sidebar/Sidebar";

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");

  // Función para ajustar el estado del Drawer basado en si es dispositivo móvil
  useEffect(() => {
    if (isMobile) {
      setDrawerOpen(false);
    }
  }, [isMobile]);

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev); // Cambia el estado de apertura del Drawer
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Navbar */}
      <Navbar handleDrawerToggle={handleDrawerToggle} />

      {/* Contenido central */}
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Sidebar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />

        {/* Contenedor del contenido de la página */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: { xs: 1, sm: 2 },
            py: 2,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FCFCFC",
            gap: { xs: 3, md: 5 },
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
